export class SnWithServiceTypeModel {
    serialNumber: string;
    deviceServiceTypeId: number;

    constructor(serialNumber: string
        , deviceServiceTypeId: number) {
        this.serialNumber = serialNumber;
        this.deviceServiceTypeId = deviceServiceTypeId;
    }
}